import { pictorialBar_children, home_pictorialBar_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxPictorialBar = {
  name: "cxPictorialBar",
  desc: "",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    /*app: [
      {
        name: "象形柱图",
        children: home_pictorialBar_children,
        group: "chart",
        sort: 10
      }
    ],*/
    bigScreen: [
      {
        name: "象形柱图",
        children: pictorialBar_children,
        type: "pictorialBarComponent",
        group: "chart",
        sort: 10
      }
    ],
   /* portal: [
      {
        name: "象形柱图",
        children: home_pictorialBar_children,
        group: "chart",
        sort: 10
      }
    ]*/
  },
  toolbars: [
    {
      name: "cxPictorialBar",
      label: "象形柱图",
      comp: {
        pictorialBarComponentData: () => import("./toolbars/pictorialBar-options-data.vue"),
        pictorialBarComponentSetting: () => import("./toolbars/pictorialBar-options-setting.vue"),
        pictorialBarComponentStyle: () => import("./toolbars/pictorialBar-options-style.vue")
      }
    }
  ]
}

export default cxPictorialBar
